/**
 * AccountNav - Role-Aware Navigation for Account Pages
 * 
 * PURPOSE: Render the appropriate navigation bar based on user role.
 * - Readers: ReaderNav (with credits display and "Buy Credits" button)
 * - Authors/Publishers/Admins: Their respective Nav without RCM elements
 * 
 * This component ensures NO Reader Credit Model UI leaks to non-Reader roles.
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ReaderNav from './ReaderNav';
import CreatorNav from './CreatorNav';
import AdminNav from './AdminNav';
import PublisherNav from './PublisherNav';

const AccountNav = () => {
  const { user } = useAuth();
  const roles = user?.roles || [];
  
  // Determine which nav to show based on highest role
  // Priority: Admin > Publisher > Author > Reader
  if (roles.includes('admin')) {
    return <AdminNav />;
  }
  
  if (roles.includes('publisher')) {
    return <PublisherNav />;
  }
  
  if (roles.includes('author') || roles.includes('creator')) {
    return <CreatorNav />;
  }
  
  // Default: Reader - show full RCM nav
  return <ReaderNav />;
};

export default AccountNav;
